var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useEffect, useState, useRef } from 'react';
import Validator from 'validator.tool';
export * from 'validator.tool';
export function useValidator(props) {
    if (props === void 0) { props = {}; }
    var validator = useRef(new Validator(__assign({}, props)));
    var _a = useState(0), upState = _a[0], forceUpdate = _a[1];
    useEffect(function () {
        if (validator.current && props.form) {
            validator.current.setForm(props.form);
        }
    }, [props.form, validator.current]);
    var handleForceUpdate = function () { return forceUpdate(upState + 1); };
    var handleSubmit = function (handle) { return function (evn) {
        evn && evn.preventDefault();
        validator.current.showMessages();
        forceUpdate(upState + 1);
        if (handle) {
            var valid = validator.current.allValid();
            handle(__assign({}, validator.current.values), valid);
        }
    }; };
    var handleReset = function (handle) { return function (evn) {
        validator.current.hideMessages();
        var val = validator.current.reset();
        handle && handle(val);
    }; };
    return {
        validator: validator.current,
        forceUpdate: handleForceUpdate,
        /** Only `Form` Support */
        handleSubmit: handleSubmit,
        /** Only `Form` Support */
        handleReset: handleReset,
    };
}
